import React, { Component, PropTypes } from 'react';
import moment from 'moment';

let $ = window.jQuery;

export default class TimePickerField extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired,
        adjustMinutes: PropTypes.number.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {
        let current = moment().add(this.props.adjustMinutes, 'minutes').format('hh:mm A');
        if (this.props.val) {
            current = moment(this.props.val, 'hh:mm A').format('hh:mm A');
        }

        $('#'+this.props.id).timepicker({
            minuteStep: 5,
            showSeconds: false,
            defaultTime: current
        }).on('changeTime.timepicker', (e) => {
            this.props.onChange($('#'+this.props.id).val());
        });

        this.setState({
            val: current
        });

        this.props.onChange(current);
    }

    componentWillReceiveProps(nextProps) {
        let current = moment().add(nextProps.adjustMinutes, 'minutes').format('hh:mm A');
        if (nextProps.val) {
            current = moment(nextProps.val, 'hh:mm A').format('hh:mm A');
        }

        this.setState({
            val: current
        }, () => {
            $('#'+this.props.id).val(current);
        });

        if (this.props.updateTime !== nextProps.updateTime) {
            let current = moment().add(this.props.adjustMinutes, 'minutes').format('hh:mm A');
            $('#'+this.props.id).val(current);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        let className = this.state.val ? 'form-control time-picker edited' : 'form-control time-picker';

        return (
            <div className="form-group form-md-line-input">
                <input type="text" className={className} id={this.props.id}
                    name={this.props.id} />

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block">{this.props.help}</span>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/TimePickerField.js
 **/